/******************************************************
 *
 ********************************************************/

"use strict";

angular.module("manager")


	.controller("CarrierCtrl", function () {


	})
;
